import React from 'react';

export interface MorganaToggleOption<T extends string> {
  label: string;
  value: T;
}

interface MorganaToggleProps<T extends string> {
  options: [MorganaToggleOption<T>, MorganaToggleOption<T>];
  value: T;
  onChange: (value: T) => void;
  colors: { primary: string; textOnPrimary: string };
  containerStyle?: React.CSSProperties;
}

export const MorganaToggle = <T extends string>({ 
  options, 
  value, 
  onChange, 
  colors,
  containerStyle = {}
}: MorganaToggleProps<T>) => {
  return (
    <div 
      className="morgana-toggle-container" 
      style={{ 
        marginBottom: 4, 
        borderColor: colors.primary,
        ...containerStyle 
      }}
    >
      {options.map((option) => (
        <div 
          key={option.value}
          className={`morgana-toggle-option ${value === option.value ? 'active' : ''}`}
          onClick={() => onChange(option.value)}
          style={{ 
            flex: 1, 
            textAlign: 'center',
            backgroundColor: value === option.value ? colors.primary : 'transparent',
            color: value === option.value ? colors.textOnPrimary : colors.primary,
            cursor: 'pointer'
          }}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};
